import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import router from '@Site/Router'
import AuthInput from './AuthInput'
import Button from '@SiteComponents/Button'
import BackLink from '@Images/back-link.svg'

import {
  validateEmail,
  handleBlurField,
  handleChangeField
} from '@Utils/AuthenticationValidationHelpers'

import {
  getLoading,
} from '@SiteModules/Authentication/selectors'

import {
  FormErrors,
} from '@SiteModules/Authentication/types'

import {
  passwordNew,
} from '@SiteModules/Authentication/actions'

const ForgotPasswordForm: React.FC = () => {
  const dispatch = useDispatch()

  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState<FormErrors>({})
  const [touched, setTouched] = useState<Record<string, boolean>>({})

  const loading = useSelector(getLoading)
  const hasErrors = Object.values(errors).some(Boolean)
  const isDisabled = !email.trim() || loading || hasErrors


  const handleEmailBlur = () => {
    handleBlurField('email', email, setTouched, setErrors, validateEmail)
  }

  const goToSignIn = () => {
    router.navigate('/users/sign_in')
  }

  const sendResetCode = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    dispatch(passwordNew({ email }))
  }

  const handleEmailChange = (val: string) => {
    setEmail(val)
    handleChangeField('email', val, touched, setErrors, validateEmail)
  }

  const renderTitle = () => {
    return (
      <React.Fragment>
        <h1 className="FormPanel__title">Reset your password</h1>
        <p className="FormPanel__subtitle">Enter your email address and we&apos;ll send you a link to reset your password.</p>
      </React.Fragment>
    )
  }

  const renderInputs = () => {
    return (
      <AuthInput
        id="forgot-password-email"
        label="Email address"
        type="email"
        placeholder="you@company.com"
        value={email}
        autoComplete="email"
        data-testid="forgot-password-email-input"
        onChange={handleEmailChange}
        onBlur={handleEmailBlur}
        error={errors.email}
      />
    )
  }

  const renderBottom = () => {
    return (
      <React.Fragment>
        <div className="FormPanel__button-area">
          <Button
            styleType="brand"
            size="large"
            caption="Send Reset Code"
            type="submit"
            disabled={isDisabled}
            data-testid="forgot-password-submit"
          />
        </div>
        <button type="button" className="FormPanel__back-link" onClick={goToSignIn}>
          <BackLink />
          Back to log in
        </button>
      </React.Fragment>
    )
  }

  return (
    <form className="ForgotPasswordForm" onSubmit={sendResetCode} noValidate>
      {renderTitle()}
      {renderInputs()}
      {renderBottom()}
    </form>
  )
}

export default ForgotPasswordForm
